import React from 'react';
import pluralize from 'pluralize';
import SvgIcon from '../../../../../../common/components/svg-icon';

const NoData = ({ working, runAI, onChangeAddToReport, aiCnt, checked, disabled }) => {
  return (
    <div className="middle">
      <h3>BuzzIQ Summary</h3>
      { working && <span className="-small">Working on a summary. May need some time...</span>}
      { !working &&
        <>
          <div className="summary -small">
            Summary has been generated for
            {!!aiCnt && <>{` ${aiCnt} ${pluralize('item', aiCnt)}.`}</>}
          </div>
          <div className="buttons">
            <a className="link" onClick={ runAI }>
              <SvgIcon name="refresh" />
              Update All Summaries
            </a>
            <div className="link">
              <input
                type="checkbox"
                id={ 'cb-all-summaries' }
                checked={ checked }
                onChange={ () => { onChangeAddToReport(!checked);} }
                disabled={ disabled }
              />
              <label className="checkbox_label" htmlFor={ 'cb-all-summaries' }>Add to Report</label>
            </div>
          </div>
        </>
      }
    </div>
  );
};

export default NoData;
